import { extendObservable } from "mobx";

export class MainStore {

    constructor() {
        extendObservable(this, {
            sessionId: `client-${new Date().getTime()}`,
            currentBotMessage: null,
            currentUserMessage: null,
            messages: [],
            minutes: [],
            parameters: {}
        });
    }

    updateSessionId(){
        this.sessionId = `client-${new Date().getTime()}`;
        console.log(this.sessionId);
    }

}

const storage = new MainStore();
window.store = storage;

export default storage